import React, { useEffect, useState } from 'react';
import { Alert, Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import moment from 'moment';
import utils from '../lib/utils';

const TollFreeNumber = ({ isOpen, onCancel, history }) => {
  const [state, setState] = useState(history);

  useEffect(() => {
    setState(history);
  }, [history]);

  return (
    <Modal isOpen={isOpen} style={{ maxWidth: '1150px' }}>
      <ModalHeader>Responsible Organizations History by Toll Free Number</ModalHeader>
      <ModalBody>
        <div className="table-header-fixed">
          <table className="provisionList">
            <thead>
              <tr>
                <th>RespOrg ID</th>
                <th>RespOrg</th>
                <th>Previous RespOrg</th>
                <th>Status</th>
                <th>Status TS</th>
                <th>Last Updated</th>
                <th>Logon Id</th>
              </tr>
            </thead>
            <tbody>
              {state.length ? (
                state?.map(item => (
                  <tr>
                    <td>{item?.respOrgId}</td>
                    <td>{item?.respOrgName}</td>
                    <td>{item?.prevRespOrgName}</td>
                    <td>{item?.tfnStatus || item?.tfnStatusId}</td>
                    <td>{utils.getDateTimeFormat(item?.statusTs, 'both')}</td>
                    <td>{utils.getDateTimeFormat(item?.lastUpdateTs, 'both')}</td>
                    <td>{item?.logonId}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={12}>
                    <Alert rowSpan={12} color="info">
                      No Record Found
                    </Alert>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button outline color="secondary" onClick={onCancel}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default TollFreeNumber;
